// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../lib/node_modules/css-loader/dist/cjs.js!../../../../../lib/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../lib/node_modules/sass-loader/dist/cjs.js!../../../../../lib/node_modules/vue-loader/lib/index.js??vue-loader-options!./Recorder.vue?vue&type=style&index=0&id=b1f1e2a6&lang=scss&scoped=true&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../lib/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("f5b7c514", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../lib/node_modules/css-loader/dist/cjs.js!../../../../../lib/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../lib/node_modules/sass-loader/dist/cjs.js!../../../../../lib/node_modules/vue-loader/lib/index.js??vue-loader-options!./Recorder.vue?vue&type=style&index=0&id=b1f1e2a6&lang=scss&scoped=true&", function() {
     var newContent = require("!!../../../../../lib/node_modules/css-loader/dist/cjs.js!../../../../../lib/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../lib/node_modules/sass-loader/dist/cjs.js!../../../../../lib/node_modules/vue-loader/lib/index.js??vue-loader-options!./Recorder.vue?vue&type=style&index=0&id=b1f1e2a6&lang=scss&scoped=true&");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}